/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl, defaultAlerts, defaultLogs} from '../../../helpers'
import { useDispatch, useSelector } from 'react-redux'
import { downLoad, get, post } from '../../../../utils/ajax'
import { APIM_VERSION, remoteRoutes } from '../../../../data/constants'
import { notificationType, triggerCSVDownload, triggerFileDownload, verificationTypeDownload } from '../../../../utils/streamlineSpecificHelpers'
import toast from 'react-hot-toast'
import { overrideToastDefaults, toastMessages } from '../../../../data/toastDefaults'
import { printDateLong, printStdDatetimeFileName } from '../../../../utils/dateHelpers'
import { DOWNLOADS_CONSTANTS } from '../../../../data/redux/downloads/reducer'
import { coreConstants } from '../../../../data/redux/coreReducer'


const HeaderNotificationsMenu: FC = () => {

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false)
  const downloadDateTime: any = printStdDatetimeFileName(new Date())
  const {scheduled, ready}: any = useSelector((state: any) => state.downloads)
  const notifications: Array<any> = useSelector((state: any) => state.core.notifications);
  
  const fetchFile = (requestId: string, fileType: string) => {
      downLoad(
          `${remoteRoutes.CSVgenerator}csv/api/exports/${requestId}/download?v=1.0`,
          (rawFile) => {
            const fileName =  `${verificationTypeDownload(fileType)} - ${downloadDateTime}.zip`
            triggerFileDownload(rawFile, fileName)
              setIsLoading(false)
              toast.success(toastMessages.generateExport.success, overrideToastDefaults);

              dispatch({
                type: coreConstants.coreNotification,
                payload: false
              });
            
              dispatch({
                type: DOWNLOADS_CONSTANTS.FINISHED,
                payload: requestId
              });
              
          },
          () => {
              setIsLoading(false)
              toast.error(toastMessages.generateExport.fail, overrideToastDefaults);
          }
      );
  }

  const fetchNotifications = () => {
    get(`${remoteRoutes.notifications}/initiator?v=${APIM_VERSION}`,
            (notifications) => {
              dispatch({type: coreConstants.coreNotifications, payload: notifications})
            },
            () => {
                //toast.error(toastMessages.default.fail, overrideToastDefaults)
            },
            () => {}
        )
  }

  const markasRead = (messageId: string) => {
      post(`${remoteRoutes.notifications}/view?v=${APIM_VERSION}`, 
        { communicationId: messageId },
        () => {
          fetchNotifications()
            toast.success(toastMessages.notifications.markasRead,  {
              id: 'markasRead',
              ...overrideToastDefaults
            });
        },
        () => {
            //toast.error(toastMessages.generateExport.fail, overrideToastDefaults);
        }
    );
}

  const showMessage = (messageId:string) => {
    markasRead(messageId)
  }

  useEffect(() => {
    if (ready?.length) {
        const readyForDownload = ready[0]
        const belongsToMe = scheduled?.find((q: { RequestId: any }) => q.RequestId === readyForDownload?.id)

        if (belongsToMe) {
            fetchFile(readyForDownload?.id, belongsToMe?.type)
        }
        
    } else {
        //setIsloading(false)
    }
    
  }, [ready]);
    
  return (
    <div className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px' data-kt-menu='true'
    >
      <div className='d-flex flex-column bg-dark rounded-top'>
        <h3 className='text-warning fw-bold px-9 mt-10 mb-6'>
          Notifications 
          {/* <span className='fs-8 opacity-75 ps-3'>24 reports</span> */}
        </h3>
  
        <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9'>
          <li className='nav-item'>
            <a
              className='nav-link text-white opacity-75 opacity-state-100 pb-4 active'
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_1'
            >
              Downloads
            </a>
          </li>
  
          <li className='nav-item'>
            <a
              className='nav-link text-white opacity-75 opacity-state-100 pb-4'
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_2'
            >
              Updates {notifications?.length > 0 && <>({notifications?.length})</>}
            </a>
          </li>
  
          <li className='nav-item'>
            <a
              className='nav-link text-white opacity-75 opacity-state-100 pb-4'
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_3'
            >
              Activity
            </a>
          </li>
        </ul>
      </div>
  
      <div className='tab-content'>
        <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
          {(scheduled.length > 0) &&
            <div className='scroll-y mh-525px my-5 px-8' style={{minHeight: '200px'}}>
              {scheduled.map((alert:any, index:any) => (
                <div key={`alert${index}`} className='d-flex flex-stack py-2'>
                  <div className='d-flex align-items-center'>
                    <div className='mb-0 me-2'>
                      <span className='fs-6 text-gray-800 text-hover-dark'>
                        {verificationTypeDownload(alert.type)}
                      </span>
                      <div className='text-gray-400 fs-7'>{alert.Status}</div>
                    </div>
                  </div>
                  <span className='fs-8'>{alert?.createdAt}</span>
                </div>
              ))}
            </div>
          }
          {(scheduled?.length > 0) && <span className='text-gray-700 fs-9 d-flex m-5'>* Please do not refresh the page until the file is downloaded</span> }

          {!scheduled.length &&
            <div className='d-flex flex-column px-9'>
              <div className='pt-10 pb-0'>
                <h3 className='text-dark text-center fw-bolder'>Downloads</h3>
                <div className='text-center text-gray-600 fw-bold pt-1'>
                  No new downloads at the moment.
                </div>
              </div>
              <div className='text-center px-4'>
                <img
                  className='mw-100 mh-200px'
                  alt='metronic'
                  src={toAbsoluteUrl('/assets/illustrations/4.png')}
                />
              </div>
            </div>
          }
  
          {/* <div className='py-3 text-center border-top'>
            <Link
              to='/crafted/pages/profile'
              className='btn btn-color-gray-600 btn-active-color-primary'
            >
              View All <KTSVG path='/assets/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
            </Link>
          </div> */}
        </div>
  
        <div className='tab-pane fade' id='kt_topbar_notifications_2' role='tabpanel'>
          {(notifications?.length > 0) &&
              <div className='scroll-y mh-525px my-5 px-8' style={{minHeight: '200px'}}>
                {notifications.map((message:any, index:any) => (
                  <div key={`alert${index}`} className='py-2 mt-0 pt-0 pointer' 
                    data-bs-toggle='modal'
                    data-bs-target={"#View_Notification"}
                    data-id={message?.id}
                    onClick={() => showMessage(message?.id)}
                  >
                    <div className='d-flex flex-stack' style={{width:'100%'}}>
                      <div className='mb-0 me-2 me-3'>
                        <span className='fs-7 text-gray-800 text-hover-dark'>
                          {message.subject}
                          <span className='fs-8 text-gray-600 ml-10 d-block'>{printDateLong(message?.createdAt)}</span>
                        </span>
                      </div>
                      <div className='badge badge-dark fw-normal fs-8 text-end'>{notificationType(message.type)}</div>
                    </div>
                    <div className="separator my-3"></div>
                  </div>
                ))}
              </div>
            }

          {(!notifications?.length) &&
            <div className='d-flex flex-column px-9'>
              <div className='pt-10 pb-0'>
                <h3 className='text-dark text-center fw-bolder'>System Updates</h3>
                <div className='text-center text-gray-600 fw-bold pt-1'>
                  Software updates provide improved security, performance, features, compatibility, and lifespan.<br /> A snapshot will be shown here.
                </div>
              </div>
    
              <div className='text-center px-4'>
                <img
                  className='mw-100 mh-200px'
                  alt='metronic'
                  src={toAbsoluteUrl('/assets/illustrations/1.png')}
                />
              </div>
            </div>
          }
        </div>
  
        <div className='tab-pane fade' id='kt_topbar_notifications_3' role='tabpanel'>
          <div className='d-flex flex-column px-9'>
            <div className='pt-10 pb-0'>
              <h3 className='text-dark text-center fw-bolder'>Recent Activity</h3>
  
              <div className='text-center text-gray-600 fw-bold pt-1'>
                Most recent activity that occurs within a system in chronological order will be shown here.
              </div>
  
            </div>
  
            <div className='text-center px-4'>
              <img
                className='mw-100 mh-200px'
                alt='metronic'
                src={toAbsoluteUrl('/assets/illustrations/17.png')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
  
}

export {HeaderNotificationsMenu}